export const financialIRM = [
    {
        value: 'Livelihood',
        key: 'livelihood',
    },
    {
        value: 'Education',
        key: 'education',
    },
    {
        value: 'Fixed deposit',
        key: 'fixed-deposit',
    }
];

export const psychologicalIRM = [
    {
        value: 'Individual Counselling',
        key: 'individual-counselling',
    },
    {
        value: 'Collective therapy',
        key: 'collective-therapy',
    },
    {
        value: 'Referral to psychiatrists',
        key: 'referral-to-psychiatrists',
    },
];

export const medicalIRM = [
    {
        value: 'Health Insurance',
        key: 'health-insurance',
    },
    {
        value: 'Surgeries',
        key: 'surgeries',
    },
    {
        value: 'Medical fund',
        key: 'medical-fund',
    }
]
